import { VIDEO_PAGE, VideoPageType } from './videoPage';

/**
 * TEMPORARY: NEED REFACTOR (LMP-5173)
 *
 * Hardcoded mapping of "open document" links for Resource Library videos
 * (view mode only). There is currently NO backend support for attaching a
 * document to a video, so this static config bridges the gap under time
 * pressure and MUST be reworked.
 *
 * Shape: page -> category name -> array indexed by the video's RENDERED position
 * within that category (the order VideoList renders them). A `null` value or a
 * missing index means "no document for this slot" and no link is shown.
 *
 * FRAGILE BY DESIGN:
 *  - Keyed by rendered index, so hiding/showing or reordering a video in the
 *    super-admin editor silently shifts every document after it.
 *  - Category keys must match the backend category `name` EXACTLY; a typo or a
 *    renamed category silently drops the links (no error — just no link shown).
 *
 * PROPER FIX: add a `documentLink` field to the Video model on the backend and
 * read it directly in VideoList, then delete this file.
 *
 * Source sheet: https://docs.google.com/spreadsheets/d/1E-myZv6AHw2a44RcUlrBiih3xRgTO6z6M2aOoytpdus
 */
export const VIDEO_DOCUMENTS: Partial<
  Record<VideoPageType, Record<string, (string | null)[]>>
> = {
  [VIDEO_PAGE.ACCOUNT_SETUP]: {
    'Account Setup': [
      'https://drive.google.com/file/d/1LwYctzNiZKEKKaN2vZrqzWxcaPb6ZJEO/view',
      'https://docs.google.com/document/d/1GmB49qeAj5RPAHgdEgAN3K-D_0Hzfa17nCgdLmoGFYI/edit?usp=sharing',
      'https://docs.google.com/document/d/1crXT1DQC58lA3_J7eG-r3bvtwKYIElkDEKlqXQVq_Io/edit?usp=sharing',
      'https://docs.google.com/document/d/1jmT5Dnw1sejub9ZCh1LxtjGgP8iED2I8p0rJpryB32M/edit?usp=sharing',
      'https://docs.google.com/document/d/13iJdmSEtAUtDwWW1iUQui7-BOJp_RRkNlDquP5iFuMw/edit?usp=sharing',
      null,
      'https://docs.google.com/document/d/1zZmPCUY_EIGCuFnuJQ0f2TZf-cKemB5nzSzY2NK1Pck/edit?usp=sharing',
      null,
      null,
      null,
    ],
  },
  [VIDEO_PAGE.SWYMO_ACADEMY]: {
    Overview: [
      'https://docs.google.com/document/d/1nvH-um-w_eMMC0Fa-gjXzXzkzMnMpv9Gto_55e0Alr4/edit?usp=sharing', // InBody Inside SWYMO
      'https://drive.google.com/file/d/17dt8DGEOuC6Q5-Fwa4wVCv6uvmCwjxQ6/view', // Results Guide PDF
    ],
    'Results Sheet': [
      'https://drive.google.com/file/d/1aDSpydgZeb0IFvRL4mC8Z1mMMcR1QGYS/view?usp=sharing',
    ],
    'Sales Masterclass': [
      'https://drive.google.com/file/d/13rN6lLWEkyIdsICJswY_VKzL0TNte9pq/view?usp=sharing',
      null,
      'https://drive.google.com/file/d/1nH6MyjqAulCu92_KKywDPbldDz_5uk_A/view?usp=drive_link',
    ],
  },

  [VIDEO_PAGE.SCAN_IQ]: {
    Monetization: [
      'https://docs.google.com/document/d/10XQ4brmmrK_NKB4G5QOyDyjuPaEpo8DsoQ0NmS3GvXM/edit?usp=sharing',
      'https://docs.google.com/document/d/1B6FUk28-6nWpbsqOYKwDHXW_xMBnC0-zQFXAVkCwXMQ/edit?usp=sharing',
    ],
    'Lead flow': [
      'https://drive.google.com/file/d/15ZZjBE0Mox29rCwKprHsoncd6-E2ftdP/view?usp=drive_link',
      'https://drive.google.com/file/d/1a30mXiDu-27H6Lw7kF40Bu3mzsGVyJhs/view?usp=sharing',
    ],
    Strategy: [
      'https://docs.google.com/document/d/1NYIRyCIMPV3nUOhOzLMixDOLpABr7mV2O_uUBkaEo0w/edit?usp=drive_link',
      'https://docs.google.com/document/d/1P2JIEyrEdXeLdPwowgSl1F7c82o-mPuomeeWcgUpFvY/edit?usp=sharing',
    ],
  },
  [VIDEO_PAGE.CHALLENGES]: {
    'Build a Challenge': [
      'https://content.lifebase.solutions/challenges/SWYMO_Challenge_Creation_Checklist.pdf',
    ],
    'Marketing & Execution': [
      'https://docs.google.com/document/d/1D3MAjd0v0dQ8d2N5vQcK4pN5DwZBGcwSyeSi7uW2RlU/edit?usp=drive_link',
    ],
  },
  [VIDEO_PAGE.BUSINESS_CENTER]: {
    Automations: [
      // Overview
      'https://docs.google.com/document/d/1crXT1DQC58lA3_J7eG-r3bvtwKYIElkDEKlqXQVq_Io/edit?tab=t.0#heading=h.w9fcg29kh6pb',
      null, // Dedicated Domain
      null, // Customize Workflows
      null, // Create a Workflow
      null, // Import Contact Lists
      null, // Phone Number
      // A2P Registration
      'https://docs.google.com/document/d/1BoDXEeSEsM4AdEROSjo5xpKTLl8e859d/edit',
    ],
  },
};
